import { render, staticRenderFns } from "./detainOne.vue?vue&type=template&id=6b90f97e&scoped=true"
var script = {}
import style0 from "./detainOne.vue?vue&type=style&index=0&id=6b90f97e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90f97e",
  null
  
)

export default component.exports